import { useEffect } from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'motion/react';
import { CloseIcon } from './icons';
import IconButton from './IconButton';

export default function Drawer({ isOpen, onClose, title, children }) {
  const reduceMotion = useReducedMotion();

  useEffect(() => {
    if (!isOpen) return;
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="aui-drawer">
          <motion.div
            className="backdrop"
            onClick={onClose}
            initial={reduceMotion ? {} : { opacity: 0 }}
            animate={reduceMotion ? {} : { opacity: 1 }}
            exit={reduceMotion ? {} : { opacity: 0 }}
            transition={{ duration: 0.15 }}
          />
          <motion.div
            className="sheet"
            initial={reduceMotion ? {} : { x: '100%' }}
            animate={reduceMotion ? {} : { x: 0 }}
            exit={reduceMotion ? {} : { x: '100%' }}
            transition={{ type: 'spring', damping: 28, stiffness: 320 }}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem' }}>
              {title && <h3 style={{ margin: 0 }}>{title}</h3>}
              <IconButton onClick={onClose} title="Cerrar">
                <CloseIcon size={16} />
              </IconButton>
            </div>
            {children}
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}
